import { render, staticRenderFns } from "./host-supply-task-new.vue?vue&type=template&id=258b1dd5&scoped=true&"
import script from "./host-supply-task-new.vue?vue&type=script&lang=js&"
export * from "./host-supply-task-new.vue?vue&type=script&lang=js&"
import style0 from "./host-supply-task-new.vue?vue&type=style&index=0&id=258b1dd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b1dd5",
  null
  
)

export default component.exports